export { default } from './Tabs';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Tabs/index.js
// module id = 237
// module chunks = 2